module.exports = __webpack_public_path__ + "img/volume75.80d2ebed.svg";